export { default } from './PageFooter.js';
